import mixpanelBrowser from "mixpanel-browser";
import { campaignParams } from "./lastTouchUTMs";
import {
  Event,
  AppSwitchProps,
  CryptoProductProps,
  Cur8DealProps,
  EventType,
  ForgotPasswordProps,
  InsightProps,
  InvestItemProps,
  LoginProps,
  ShortlistedItemProps,
  SignupProps,
  TwoFaAttemptedProps,
  TwoFaSuccessProps,
  TabChangedProps,
  PageViewProps,
  InitArgs,
  cur8PageViewEvents,
  AppNames,
  AnalyticsActions,
  AppStatusProps,
  AuthLandingCTAProps,
  NotificationProps,
  NotificationAcceptance,
  NotificationDeliveredProps,
  NotificationOpenedProps,
  SetNPSProps,
  SetNPSReasonProps,
  NPSFormClickedProps,
  KycYotiCheck,
  KycCheck,
  AddInvestmentClickedProps,
  DownloadInvestmentStatementClickedProps,
  WithdrawClickedProps,
  MembershipProps,
  NotificationCtaPrompt,
  TimelineEventProps,
  BankVerificationMethodSelectedProps,
  BankVerificationAttemptedProps,
  BankAccountsUpdatedProps,
  BankAccountsRulesViewedProps,
  BankAccountsFailureViewedProps,
  BankAccountsFailureActionClickedProps,
  CommitmentEarningsViewedProps,
  CommitmentEarningsSelectedProps,
  CurrencyWarningRespondedProps,
  BankAccountsPageViewedProps,
  BankAccountCapacity,
  BankAccountStatusProperty,
  BankAccountEntryPoint,
  BankAccountVerificationFailureReason,
  EarningsBankAccountSource,
  BankAccountCapacityProps,
  BankAccountSetProps,
  BankAccountsConnectedProps,
  SaleRequestProps,
  SaleConfirmationProps,
  OneTimeMessageProps,
  PortfolioDashboardFilterClickedProps,
  DocumentsPageViewedProps,
  DocumentsPageDownloadedProps,
  IncomeDecisionProps,
  AddBankAccountProps,
  CommitmentFlowPageViewedProps,
  CommitmentDetailsPageViewedProps,
  InvestmentCommitted,
  PaymentConfirmed,
  PlaidPaymentProps,
  ZakatCalculatorCompletedProps,
  ZakatDonationAmountProps,
  DealBotOpenedProps,
  DealBotClosedProps,
  DealBotQuestionSentProps,
  DealBotResponseReceivedProps,
  DealBotErrorProps,
  DealBotFeedbackSubmittedProps,
  DealBotDealChangedProps,
  DealBotConversationDeletedProps,
  TaxResidencyProps,
  DealDetailsTabClickedProps,
  DealDetailsPageViewedProps,
  InvestmentUpdatesTabClickedProps,
  InvestmentUpdateViewedProps,
  DealDetailsInvestBlockedShownProps,
  DealDetailsInvestClickedProps,
  DealDetailsDocumentOpenedProps,
  DealDetailsCalculatorUsedProps,
  DealDetailsVideoPlayedProps,
  DealDetailsWebinarClickedProps,
  DealDetailsGlossaryOpenedProps,
  DealDetailsManageHoldingOpenedProps,
  DealDetailsManageHoldingOptionClickedProps,
  DealDetailsShariaCtaClickedProps,
  PaymentAcknowledgedProps,
  WatchlistButtonClickedProps,
  QuizStartedProps,
  QuizQuestionCompletedProps,
  QuizAbandonedProps,
  QuizHelpModalOpenedProps,
  FeedbackFormViewedProps,
  HeaderFCAClickedProps,
  ShariaComplianceClickedProps,
  ShariaCompliancePageViewedProps,
  StartupHubViewedProps,
  StartupHubFilterClickedProps,
  StartupHubEisCertificateClickedProps,
  StartupHubEisExplanationClickedProps,
  StartupHubGlossaryClickedProps,
  StartupHubEisDocumentsClickedProps,
  HomepageIntroductionStartedProps,
  HomepageIntroductionStepViewedProps,
  HomepageIntroductionSkippedProps,
  HomepageIntroductionCompletedProps,
  DealTourOpenedProps,
  DealTourStepViewedProps,
  DealTourExitedProps,
  DealTourCompletedProps,
  IfIsaCtaProps,
  IfIsaCtaDismissedProps,
  IfIsaFullSourceProps,
  ActivityTimelineViewedProps,
  UserIdIsMemberBaseProps,
  IfIsaTransferInSubmitFormProps,
  DealComparisonViewedProps,
  DealComparisonDealSelectedProps,
  DealComparisonCardExpandedProps,
  DealComparisonDetailsClickedProps,
  DealComparisonCalculateReturnsClickedProps,
  DealComparisonCalculateReturnsFailedProps,
  DealComparisonDealChangedProps,
  NavigationMenuClickedProps,
  DealExplorerBaseProps,
  DealExplorerPageViewedProps,
  DealTimelineInvestmentBreakdownExpandendProps,
  CurrentPortfolioValueInfoClickedProps,
  TimelineGlossaryClickedProps,
  FCAQuestionsAnsweredProps,
  CalculatorEntryPointClickedProps,
  CalculatorViewedProps,
  CalculatorEditButtonClickedProps,
  CalculatorInvestButtonClickedProps,
  CalculatorDealChangedProps,
  CalculatorChartInteractedProps,
  CalculatorTotalFeesExpandedProps,
  CalculatorFaqOpenedProps,
  CalculatorFaqId,
  CalculatorComparisonViewedProps,
  CalculatorConfigurationSubmittedProps,
  CodePushForceUpdateShownProps,
  CodePushForceUpdateAcceptedProps,
  CodePushUpdateCompletedProps,
  NucleusReallocationsUpdatedProps,
  NucleusBankAccountDetailsMatchProps,
  NucleusBankAccountPageViewedProps,
  NucleusEntryPoint,
  NucleusSubAppOpenedProps,
  NucleusActionFailedProps,
  NucleusLookupElement,
  NucleusLookupSearchedProps,
  NucleusLookupElementClickedProps,
  NucleusFrozenDayLineOpenedProps,
  NucleusFrozenDayLineSavedProps,
  IsaFlowType,
  IsaSpendBucket,
  InvestmentCapacity,
  DealStatus,
  IsaPageViewedProps,
  IsaNavbarClickedProps,
  TodoCardClickedProps,
  IsaJourneyCtaClickedProps,
  IsaCalculatorConfigurationSubmittedProps,
  IsaReminderSubmittedProps,
  IsaJourneyStartedProps,
  IsaJourneyAbandonedProps,
  IsaFlowTypeOnlyProps,
  IsaTransferStepCompletedProps,
  IsaTransferStatusUpdatedProps,
  IsaTransferCompletedProps,
  CommitmentCapacityPageViewedProps,
  CommitmentIsaPromptViewedProps,
  CommitmentNumberPageViewedProps,
  CommitmentReviewViewedProps,
  IsaTrackerClickedProps,
  IsaWrapRequestEntryPointClickedProps,
  IsaWrapRequestFundSelectedProps,
  IsaWrapRequestAmountEnteredProps,
  IsaWrapRequestAllowanceErrorShownProps,
  IsaWrapRequestReviewScreenViewedProps,
  IsaWrapRequestSubmittedProps,
  EventsCardTappedProps,
  EventsRegisterTappedProps,
  EventsJoinNowTappedProps,
  EarningsCalendarInvestorPageViewedProps,
  EarningsCalendarNonInvestorPageViewedProps,
  EarningsDetailUpcomingPageViewedProps,
  EarningsDetailReceivedPageViewedProps,
  ManageEarningsPageViewedProps,
  EarningsCalendarEntryPointClickedProps,
  EarningsCalendarItemClickedProps,
  EarningsPreferenceManageClickedProps,
  EarningsCalendarInvestNowClickedProps,
  EarningsDetailPreferenceClickedProps,
  EarningsDetailContactSupportClickedProps,
  EarningsBankAccountSwitchClickedProps,
  EarningsCalendarRetryClickedProps,
  FundRestructureBannerTappedProps,
  FundRestructureAllocationViewedProps,
  FundRestructureNoticePeriodSelectedProps,
  FundRestructureIncomeDecisionProps,
  FundRestructureSubmitProps,
  FundRestructureSubmitSucceededProps,
  FundRestructureSuccessViewedProps,
  FundRestructureSummaryViewedProps,
  PortfolioStatementAccountType,
  PortfolioStatementPeriodType,
  PortfolioStatementOpenedProps,
  PortfolioStatementPeriodSelectedProps,
  PortfolioStatementGeneratedProps,
  PortfolioStatementDownloadedProps,
  TransitionFlowProps,
  DealDetailsSectionTab,
  DealDetailsInteractionDetail,
  TransitionSubmitFailureReason,
  TransitionBackendRecord,
  TransitionFlowAction,
  ActivityTimelineInteractionProps,
  LiveDealsInteractionProps,
  FundOverviewInteractionProps,
  PortfolioInteractionProps,
  HomePageInteractionProps,
  NotificationsInteractionProps,
  DealDetailsInteractionProps,
  TransitionFlowName,
  TransitionStepName,
  TransitionRequestKindName,
  TransitionAmountMode,
  TransitionDirection,
  ActivityReceiptPageViewedProps,
  AuthMethod,
  TwoFaMethod,
  AuthSignupFailedProps,
  AuthLoginSuccessProps,
  AuthLoginFailedProps,
  AuthTwoFaRequiredProps,
  AuthTwoFaFailedProps,
  AuthEmailVerificationFailedProps,
  OnboardingMandatoryQuestionAnsweredProps,
  OnboardingMandatoryQuestionnaireCompletedProps,
  OnboardingEmailPreferencesCompletedProps,
  OnboardingSocialAttributionCompletedProps,
  OnboardingExperimentExposedProps,
  OnboardingPreAppGateEnteredProps,
  OnboardingPreAppGateCompletedProps,
  OnboardingDealChecklistSource,
  OnboardingDealChecklistViewedProps,
  OnboardingDealStepClickedProps,
  OnboardingDealContinuationReturnedProps,
  OnboardingDealStepCompletedProps,
  OnboardingDealUnlockedProps,
  OnboardingQuizResultClickedProps,
  OnboardingContinueBannerClickedProps,
  OnboardingVersion,
  OnboardingStep,
  OnboardingNextStep,
  OnboardingCompletedStep,
  OnboardingCardState,
  DealCardState,
  DealCardStateProps,
  OnboardingCtaPosition,
  OnboardingReturnReason,
  OnboardingDestination,
  OnboardingQuizResult,
  OnboardingQuizResultAction,
  OnboardingAnalyticsProps,
  OnboardingBasicInfoCompletedProps,
  OnboardingCertificationSelectedProps,
  OnboardingAccreditationCompletedProps,
  OnboardingQuizFailedProps,
  OnboardingVerificationDocumentUploadedProps,
  OnboardingVerificationUploadFailedProps,
  OnboardingVerificationCompletedProps,
  OnboardingBackPressedProps,
  OnboardingHelpTappedProps,
  OnboardingSectionFailedProps,
} from "./types";

export const init = ({
  APP_NAME,
  GOOGLE_ADS_ID,
  GOOGLE_ADS_SIGNUP_TAG_ID,
  MIXPANEL_TOKEN,
  channel = "web",
  mixpanel = mixpanelBrowser,
  customerIO,
  mixpanelInitOptions,
  mixpanelReady,
}: InitArgs) => {
  const ready =
    mixpanelReady ??
    Promise.resolve().then(() => {
      if (channel === "mobile") {
        // @ts-expect-error mobile library has no params
        return mixpanel.init();
      }

      return mixpanel.init(MIXPANEL_TOKEN, {
        ...mixpanelInitOptions,
        api_host: "https://api-eu.mixpanel.com",
      });
    });

  return async function useAnalytics<T extends Event>(
    event: T
  ): Promise<EventType<T>> {
    await ready.catch((error) => {
      console.warn("Mixpanel initialization failed:", { error });
    });

    // Don't break during SSR
    if (
      typeof (globalThis as { document?: unknown }).document !== "undefined" &&
      channel !== "mobile"
    ) {
      campaignParams(mixpanel);
    }

    // ------------------------------------------------------------------
    // Unified tracking helper. Ensure every analytics event is forwarded
    // to both Mixpanel and Customer.io so that the rest of the codebase
    // only needs to invoke a single function.
    // ------------------------------------------------------------------
    const track = (eventName: string, props: Record<string, unknown> = {}) => {
      try {
        mixpanel.track(eventName, props);
      } catch (error) {
        console.warn("Mixpanel.track failed:", { error, eventName });
      }

      try {
        customerIO?.track?.(eventName, props);
      } catch (error) {
        console.warn("CustomerIO.track failed:", { error, eventName });
      }
    };

    const toNonEmptyString = (value: unknown): string | null => {
      if (typeof value !== "string") {
        return null;
      }

      const trimmed = value.trim();
      return trimmed.length > 0 ? trimmed : null;
    };

    const safeMixpanelIdentify = async (distinctId: unknown) => {
      const id = toNonEmptyString(distinctId);
      if (!id) {
        console.warn("Invalid distinctId provided to Mixpanel.identify:");
        return;
      }

      try {
        // Mobile SDK returns Promise, web SDK is sync - await handles both
        await mixpanel.identify(id);
      } catch (error) {
        console.warn("Mixpanel.identify failed:", { error });
      }
    };

    const safeMixpanelAlias = async (aliasId: unknown) => {
      const id = toNonEmptyString(aliasId);
      if (!id) {
        console.warn("Invalid distinctId provided to Mixpanel.alias:");
        return;
      }

      try {
        // Mobile SDK returns Promise, web SDK is sync - await handles both
        await mixpanel.alias(id);
      } catch (error) {
        console.warn("Mixpanel.alias failed:", { error });
      }
    };

    let func: unknown;

    switch (event) {
      case "signupAttempt": {
        func = async (args: SignupProps) => {
          const email = toNonEmptyString(
            (args as unknown as { email?: unknown })?.email
          );
          if (!email) {
            console.warn("Invalid email provided to signupAttempt analytics:");
            return;
          }

          if (email.includes("@delete.com") || email.includes("@test.com")) {
            return;
          }

          // Identify before tracking so the event is attributed to the correct user
          await safeMixpanelAlias(email);
          await safeMixpanelIdentify(email);
          mixpanel.people?.set_once({
            $email: email,
            "Sign Up Date": new Date().toISOString(),
            "Account Type": "IFG Wealth",
          });
          track("all:signup_attempted", {
            email,
            app: APP_NAME,
            channel,
            ...(args.method ? { method: args.method } : {}),
            ...(args.attribution ? { attribution: args.attribution } : {}),
            ...(args.utm ? { utm: args.utm } : {}),
          });

          // Identify in Customer.io
          if (channel === "mobile") {
            await customerIO?.identify({ userId: email });
          } else {
            await customerIO?.identify(email);
          }

          // only available in production
          const gtag = (
            globalThis as {
              gtag?: (
                type: string,
                action: string,
                params: { send_to: string }
              ) => void;
            }
          ).gtag;
          if (gtag) {
            gtag("event", "conversion", {
              send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_SIGNUP_TAG_ID}`,
            });
          }
        };

        break;
      }

      case "signupSuccess": {
        func = async (args: SignupProps) => {
          const email = toNonEmptyString(
            (args as unknown as { email?: unknown })?.email
          );
          if (!email) {
            console.warn("Invalid email provided to signupSuccess analytics:", {
              email: (args as unknown as { email?: unknown })?.email,
            });
            return;
          }

          await safeMixpanelIdentify(email);
          if (channel === "mobile") {
            await customerIO?.identify({ userId: email });
          } else {
            await customerIO?.identify(email);
          }

          track("all:signup_success", {
            email,
            app: APP_NAME,
            distinct_id: email,
            ...(args.onboarding_flow
              ? { onboarding_flow: args.onboarding_flow }
              : {}),
            ...(args.onboarding_version
              ? { onboarding_version: args.onboarding_version }
              : {}),
            ...(args.anchoring_deal_id
              ? { anchoring_deal_id: args.anchoring_deal_id }
              : {}),
          });
        };

        break;
      }

      case "login": {
        func = async (args: LoginProps) => {
          const email = toNonEmptyString(
            (args as unknown as { email?: unknown })?.email
          );
          if (!email) {
            console.warn("Invalid email provided to login analytics:", {
              email: (args as unknown as { email?: unknown })?.email,
            });
            return;
          }

          if (email.includes("@delete.com") || email.includes("@test.com")) {
            return;
          }

          // Identify before tracking so the event is attributed to the correct user
          await safeMixpanelIdentify(email);
          mixpanel.people?.set({
            LatestLoginDate: new Date().toISOString(),
          });
          mixpanel.people?.append("list_logins", new Date().toISOString());
          track("all:login_attempted", {
            email,
            app: APP_NAME,
            channel,
            ...(args.method ? { method: args.method } : {}),
          });

          // Identify in Customer.io
          if (channel === "mobile") {
            await customerIO?.identify({ userId: email });
          } else {
            await customerIO?.identify(email);
          }
        };

        break;
      }

      case "twoFaAttempted": {
        func = (args: TwoFaAttemptedProps) => {
          track("all:2fa_attempted", {
            channel: args.channel,
            method: args.method,
            app: APP_NAME,
          });
        };

        break;
      }

      case "twoFaSuccess": {
        func = (args: TwoFaSuccessProps) => {
          track("all:2fa_success", {
            channel: args.channel,
            method: args.method,
            app: APP_NAME,
          });
        };

        break;
      }

      // --- auth-v2 handlers for signup, login, 2FA, and email verification outcomes ---

      case "signupFailed": {
        func = (args: AuthSignupFailedProps) => {
          track("all:signup_failed", { ...args, app: APP_NAME, channel });
        };

        break;
      }

      case "loginSuccess": {
        func = async (args: AuthLoginSuccessProps) => {
          await safeMixpanelIdentify(args.email);
          if (channel === "mobile") {
            await customerIO?.identify({ userId: args.email });
          } else {
            await customerIO?.identify(args.email);
          }

          track("all:login_success", { ...args, app: APP_NAME, channel });
        };

        break;
      }

      case "loginFailed": {
        func = (args: AuthLoginFailedProps) => {
          track("all:login_failed", { ...args, app: APP_NAME, channel });
        };

        break;
      }

      case "twoFaRequired": {
        func = (args: AuthTwoFaRequiredProps) => {
          track("all:2fa_required", { ...args, app: APP_NAME });
        };

        break;
      }

      case "twoFaFailed": {
        func = (args: AuthTwoFaFailedProps) => {
          track("all:2fa_failed", { ...args, app: APP_NAME });
        };

        break;
      }

      case "emailVerificationFailed": {
        func = (args: AuthEmailVerificationFailedProps) => {
          track("all:emailVerification_failed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      // --- onboarding-v2 handlers for progress, choices, verification, and support actions ---

      case "onboardingMandatoryQuestionAnswered": {
        func = (args: OnboardingMandatoryQuestionAnsweredProps) => {
          track("cur8:onboardingMandatoryQuestion_answered", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingMandatoryQuestionnaireCompleted": {
        func = (args: OnboardingMandatoryQuestionnaireCompletedProps) => {
          track("cur8:onboardingMandatoryQuestionnaire_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingEmailPreferencesCompleted": {
        func = (args: OnboardingEmailPreferencesCompletedProps) => {
          track("cur8:onboardingEmailPreferences_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          if (args.email_preference) {
            mixpanel.people?.set({ email_preference: args.email_preference });
          }
        };

        break;
      }

      case "onboardingSocialAttributionCompleted": {
        func = (args: OnboardingSocialAttributionCompletedProps) => {
          track("cur8:onboardingSocialAttribution_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          if (args.attribution_source) {
            mixpanel.people?.set({
              attribution_source: args.attribution_source,
            });
          }
        };

        break;
      }

      case "onboardingExperimentExposed": {
        func = (args: OnboardingExperimentExposedProps) => {
          track("experiment_exposed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          mixpanel.people?.set({ onboarding_flow: args.onboarding_flow });
        };

        break;
      }

      case "onboardingPreAppGateEntered": {
        func = (args: OnboardingPreAppGateEnteredProps) => {
          track("cur8:onboardingPreAppGate_entered", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingPreAppGateCompleted": {
        func = (args: OnboardingPreAppGateCompletedProps) => {
          track("cur8:onboardingPreAppGate_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingDealChecklistViewed": {
        func = (args: OnboardingDealChecklistViewedProps) => {
          track("cur8:onboardingDealChecklist_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingDealStepClicked": {
        func = (args: OnboardingDealStepClickedProps) => {
          track("cur8:onboardingDealStep_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingDealContinuationReturned": {
        func = (args: OnboardingDealContinuationReturnedProps) => {
          track("cur8:onboardingDealContinuation_returned", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingDealStepCompleted": {
        func = (args: OnboardingDealStepCompletedProps) => {
          track("cur8:onboardingDealStep_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingDealUnlocked": {
        func = (args: OnboardingDealUnlockedProps) => {
          track("cur8:onboardingDeal_unlocked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingQuizResultClicked": {
        func = (args: OnboardingQuizResultClickedProps) => {
          track("cur8:onboardingQuizResult_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingIdentityScanSkipped": {
        func = (args: OnboardingAnalyticsProps = {}) => {
          track("cur8:onboardingIdentityScan_skipped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingContinueBannerClicked": {
        func = (args: OnboardingContinueBannerClickedProps) => {
          track("cur8:onboardingContinueBanner_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingBasicInfoCompleted": {
        func = (args: OnboardingBasicInfoCompletedProps) => {
          track("cur8:onboardingBasicInfo_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          // Skip empty-string traits so a partial state doesn't
          // overwrite a legitimately set profile value. Booleans and
          // numbers pass through unconditionally. `source_of_funds` is
          // on the event itself (for funnel slicing) but deliberately
          // not on the user profile; matches the spec's section 5
          // traits table.
          mixpanel.people?.set({
            ...(args.age_band ? { age_band: args.age_band } : {}),
            ...(args.country ? { country: args.country } : {}),
            ...(args.nationality ? { nationality: args.nationality } : {}),
            is_uk_tax_resident: args.is_uk_tax_resident,
          });
        };

        break;
      }

      case "onboardingCertificationSelected": {
        func = (args: OnboardingCertificationSelectedProps) => {
          track("cur8:onboardingAccreditation_certificationSelected", {
            ...args,
            app: APP_NAME,
            channel,
          });
          mixpanel.people?.set({ investor_certification: args.certification });
        };

        break;
      }

      case "onboardingAccreditationCompleted": {
        func = (args: OnboardingAccreditationCompletedProps) => {
          track("cur8:onboardingAccreditation_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingQuizPassed": {
        func = (args: OnboardingAnalyticsProps = {}) => {
          track("cur8:onboardingQuiz_passed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          mixpanel.people?.set({ quiz_passed_at: new Date().toISOString() });
        };

        break;
      }

      case "onboardingQuizFailed": {
        func = (args: OnboardingQuizFailedProps) => {
          track("cur8:onboardingQuiz_failed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingVerificationDocumentUploaded": {
        func = (args: OnboardingVerificationDocumentUploadedProps) => {
          track("cur8:onboardingVerification_documentUploaded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingVerificationUploadFailed": {
        func = (args: OnboardingVerificationUploadFailedProps) => {
          track("cur8:onboardingVerification_uploadFailed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingVerificationCompleted": {
        func = (args: OnboardingVerificationCompletedProps) => {
          track("cur8:onboardingVerification_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          if (args.kyc_status) {
            mixpanel.people?.set({ kyc_status: args.kyc_status });
          }
        };

        break;
      }

      case "onboardingCompleted": {
        func = (args: OnboardingAnalyticsProps = {}) => {
          track("cur8:onboarding_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
          mixpanel.people?.set({
            onboarding_completed_at: new Date().toISOString(),
          });
        };

        break;
      }

      case "onboardingBackPressed": {
        func = (args: OnboardingBackPressedProps) => {
          track("cur8:onboarding_backPressed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingHelpTapped": {
        func = (args: OnboardingHelpTappedProps) => {
          track("cur8:onboarding_helpTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "onboardingSectionFailed": {
        func = (args: OnboardingSectionFailedProps) => {
          track("cur8:onboardingSection_failed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "pageView": {
        func = (args: PageViewProps) => {
          const { eventName, ...rest } = args;
          track(eventName, {
            ...rest,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "tabChanged": {
        func = (args: TabChangedProps) => {
          track(args.eventName, {
            app: APP_NAME,
            tab_id: args.tab_id,
          });
        };

        break;
      }

      case "willSubmission": {
        func = () => {
          track("wills:checkout_clicked", {
            app: APP_NAME,
          });
        };

        break;
      }

      case "compareShortlist": {
        func = (args: ShortlistedItemProps) => {
          track("compare:shortlist_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "compareInvest": {
        func = (args: InvestItemProps) => {
          track("compare:investNow_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "insightViewClick": {
        func = (args: InsightProps) => {
          track("track:insight_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "insightCTAClick": {
        func = (args: InsightProps) => {
          track("track:insightCTA_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8JoinClick": {
        func = () => {
          track("wealth:cur8ProductPageJoin_clicked", {
            app: APP_NAME,
          });
        };

        break;
      }

      case "authLandingCTAClick": {
        func = (args: AuthLandingCTAProps) => {
          track("all:authLandingCTA_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "forgotPasswordClick":
      case "forogtPasswordClick": {
        func = () => {
          track("all:forgotPassword_clicked", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "forgotPasswordSubmitEmailClick":
      case "forogtPasswordSubmitEmailClick": {
        func = (args: ForgotPasswordProps) => {
          track("all:forgotPasswordSubmitEmail_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "forgotPasswordSetPasswordClick":
      case "forogtPasswordSetPasswordClick": {
        func = () => {
          track("all:forgotPasswordSetPassword_clicked", {
            app: APP_NAME,
          });
        };

        break;
      }

      case "appSwitch": {
        func = async (args: AppSwitchProps) => {
          track("all:app_switched", {
            From: APP_NAME,
            To: args.destination,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8DealDetailsPageView": {
        func = async (args: Cur8DealProps) => {
          track("cur8:dealDetails_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }
      case "cur8DealDetailsCommitInvestmentClick": {
        func = async (args: Cur8DealProps) => {
          track("cur8:dealDetailsCommitInvestment_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }
      case "compareCryptoBuyNowClick": {
        func = async (args: CryptoProductProps) => {
          track("compare:cryptoBuyNowClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }
      case "cur8BankDetailsPageView": {
        func = async (args: Cur8DealProps) => {
          track("cur8:bankDetails_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }
      case "bankVerificationMethodSelected": {
        func = async (args: BankVerificationMethodSelectedProps) => {
          track("cur8:bankAccounts_methodSelected", {
            ...args,
            app: APP_NAME,
          });
        };
        break;
      }
      case "bankVerificationAttempted": {
        func = async (args: BankVerificationAttemptedProps) => {
          track("cur8:bankAccounts_submissionAttempted", {
            ...args,
            app: APP_NAME,
          });
        };
        break;
      }
      case "bankAccountsConnected": {
        func = async (args: BankAccountsConnectedProps) => {
          track("cur8:bankAccounts_connected", {
            ...args,
            app: APP_NAME,
          });
        };
        break;
      }
      case "bankAccountsUpdated": {
        func = async (args: BankAccountsUpdatedProps) => {
          track("cur8:bankAccounts_updated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "bankAccountsRulesViewed": {
        func = async (args: BankAccountsRulesViewedProps) => {
          track("cur8:bankAccounts_rulesViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "bankAccountsFailureViewed": {
        func = async (args: BankAccountsFailureViewedProps) => {
          track("cur8:bankAccounts_failureViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "bankAccountsFailureActionClicked": {
        func = async (args: BankAccountsFailureActionClickedProps) => {
          track("cur8:bankAccounts_failureActionClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "commitmentEarningsViewed": {
        func = async (args: CommitmentEarningsViewedProps) => {
          track("cur8:commitmentEarnings_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "commitmentEarningsSelected": {
        func = async (args: CommitmentEarningsSelectedProps) => {
          track("cur8:commitmentEarnings_selected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "currencyWarningResponded": {
        func = async (args: CurrencyWarningRespondedProps) => {
          track("cur8:currencyWarning_responded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }
      case "appOpened": {
        func = async (args: AppStatusProps) => {
          track("all:app_opened", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }
      case "appClosed": {
        func = async (args: AppStatusProps) => {
          track("all:app_closed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "notificationCTAClicked": {
        func = async ({
          name,
          notificationId,
          title,
          source,
        }: NotificationProps) => {
          track("cur8:notificationCTA_clicked", {
            channel,
            app: APP_NAME,
            notification_name: name,
            notification_id: notificationId,
            notification_title: title,
            notification_source: source,
          });
        };

        break;
      }

      case "notificationDelivered": {
        func = async ({
          notificationId,
          title,
          email,
        }: NotificationDeliveredProps) => {
          track("cur8:notification_delivered", {
            channel,
            app: APP_NAME,
            notification_id: notificationId,
            notification_title: title,
            email,
          });
        };

        break;
      }

      case "notificationOpened": {
        func = async ({
          name,
          type,
          userNotificationId,
          foreground,
        }: NotificationOpenedProps) => {
          track("cur8:notification_opened", {
            channel,
            app: APP_NAME,
            notification_name: name,
            notification_type: type,
            user_notification_id: userNotificationId,
            foreground,
          });
        };

        break;
      }

      case "notificationsEnabled": {
        func = async ({
          email,
          notificationId,
          title,
          name,
          source,
        }: NotificationAcceptance) => {
          track("cur8:notifications_enabled", {
            email,
            notification_id: notificationId,
            notification_title: title,
            notification_name: name,
            notification_source: source,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "notificationsDisabled": {
        func = async ({
          email,
          notificationId,
          title,
          name,
          source,
        }: NotificationAcceptance) => {
          track("cur8:notifications_disabled", {
            email,
            notification_id: notificationId,
            notification_title: title,
            notification_name: name,
            notification_source: source,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "notificationPromptCTA_clicked": {
        func = async ({
          email,
          action_taken,
          notificationId,
          title,
          name,
          source,
        }: NotificationCtaPrompt) => {
          track("cur8:notificationPromptCTA_clicked", {
            email,
            action_taken,
            notification_id: notificationId,
            notification_title: title,
            notification_name: name,
            notification_source: source,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "kycYotiCheck": {
        func = async (args: KycYotiCheck) => {
          track("cur8:yotiKyc_check", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "kycCheck": {
        func = async (args: KycCheck) => {
          track("cur8:kyc_check", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "addInvestmentClicked": {
        func = async ({ deal_name, ...args }: AddInvestmentClickedProps) => {
          track("cur8:addInvestment_clicked", {
            ...args,
            channel,
            app: APP_NAME,
            deal_name,
          });
        };

        break;
      }

      case "setNPS": {
        func = ({ NPS, email }: SetNPSProps) => {
          track("cur8:nps_set", {
            NPS,
            email,
          });
          mixpanel.people?.set({ NPS });
        };

        break;
      }

      case "setNPSReason": {
        func = ({ NPSReason, email }: SetNPSReasonProps) => {
          track("cur8:npsReason_set", {
            NPSReason,
            email,
          });
          mixpanel.people?.set({ NPSReason });
        };

        break;
      }

      case "NPSFormClicked": {
        func = (args: NPSFormClickedProps) => {
          const data = {
            ...args,
            channel,
            app: APP_NAME,
          };

          track("cur8:npsForm_clicked", data);
        };

        break;
      }

      case "downloadInvestmentStatementClick": {
        func = async (args: DownloadInvestmentStatementClickedProps) => {
          track("cur8:generateInvestmentStatement_clicked", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "withdrawClick": {
        func = async (args: WithdrawClickedProps) => {
          track("cur8:withdrawButton_clicked", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "getMembershipClicked": {
        func = async (args: MembershipProps) => {
          track("cur8:getMembership_clicked", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "membershipPurchased": {
        func = async (args: MembershipProps) => {
          track("cur8:membership_purchased", {
            ...args,
            channel,
            app: APP_NAME,
          });
        };

        break;
      }

      case "feesAndReturnsCalculatorInvestNow": {
        func = (args: AppStatusProps) => {
          track("cur8:feesAndReturnsCalculator_investNow", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "zakatCalculatorClicked": {
        func = (args: AppStatusProps) => {
          track("zakat:zakatCalculator_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatCalculatorCompleted": {
        func = (args: ZakatCalculatorCompletedProps) => {
          track("zakat:zakatCalculator_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatCheckoutSuccess": {
        func = (args: ZakatDonationAmountProps) => {
          track("zakat:checkout_success", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatPaymentSummaryPageViewed": {
        func = () => {
          track("zakat:paymentSummary_pageViewed", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatGiftAidPageViewed": {
        func = () => {
          track("zakat:giftAid_pageViewed", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatCalculationSummaryPageViewed": {
        func = (args: ZakatCalculatorCompletedProps) => {
          track("zakat:calculationSummary_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "zakatCheckoutInitiated": {
        func = (args: ZakatDonationAmountProps) => {
          track("zakat:checkout_initiated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "cur8ZakatStatementDownloaded": {
        func = () => {
          track("cur8:zakatStatement_downloaded", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "resumeInstalmentClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:resumeInstalment_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "cancelOneOffPaymentClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:cancelOneOffPayment_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "cancelInstalmentPlanClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:cancelInstalmentPlan_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "activityTimelineCardClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:activityTimelineCard_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "paymentAcknowledgementClicked": {
        func = ({
          deal_name,
          amount,
          test_variant,
        }: PaymentAcknowledgedProps) => {
          track("cur8:paymentAcknowledgement_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
            amount,
            test_variant,
          });
        };

        break;
      }

      case "activityTimelineViewed": {
        func = (args: ActivityTimelineViewedProps) => {
          track("cur8:activityTimeline_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "activityTimelineDocumentsTabClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:activityTimelineDocumentsTab_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "activityTimelineTabClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:activityTimelineTab_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "saleRequestOptionClicked": {
        func = ({ deal_name, payment_ref }: SaleRequestProps) => {
          track("cur8:saleRequestOption_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
            payment_ref,
          });
        };

        break;
      }

      case "saleRequestBankAccountSelected": {
        func = ({ deal_name, payment_ref }: SaleRequestProps) => {
          track("cur8:saleRequestBankAccount_selected", {
            app: APP_NAME,
            channel,
            deal_name,
            payment_ref,
          });
        };

        break;
      }

      case "saleRequestConfirmationClicked": {
        func = ({
          deal_name,
          payment_ref,
          amount,
          liquidationType,
          reason,
        }: SaleConfirmationProps) => {
          track("cur8:saleRequestConfirmation_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
            payment_ref,
            amount,
            liquidationType,
            reason,
          });
        };

        break;
      }

      case "mandatoryFCAQuestionsPageViewed": {
        func = () => {
          track("cur8:mandatoryFCAQuestions_pageViewed", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "mandatoryFCAQuestionsAnswered": {
        func = (args: FCAQuestionsAnsweredProps) => {
          track("cur8:mandatoryFCAQuestions_answered", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "paymentDetailsFCAQuestionsPageViewed": {
        func = () => {
          track("cur8:paymentDetailsFCAQuestions_pageViewed", {
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "paymentDetailsFCAQuestionsAnswered": {
        func = (args: FCAQuestionsAnsweredProps) => {
          track("cur8:paymentDetailsFCAQuestions_answered", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "oneTimeMessageViewed": {
        func = (args: OneTimeMessageProps) => {
          track("cur8:oneTimeMessage_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "oneTimeMessageAcknowledged": {
        func = (args: OneTimeMessageProps) => {
          track("cur8:oneTimeMessage_acknowledged", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "portfolioDashboardFilterClicked": {
        func = (args: PortfolioDashboardFilterClickedProps) => {
          track("cur8:portfolioDashboard_filterClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "documentsPageViewed": {
        func = (args: DocumentsPageViewedProps) => {
          track("cur8:documentsPage_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "documentsPageDownloaded": {
        func = (args: DocumentsPageDownloadedProps) => {
          track("cur8:documentsPage_downloaded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "incomeDecisionClicked": {
        func = (args: IncomeDecisionProps) => {
          track("cur8:manageEarningsSavePreference_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "incomeDecisionUpdated": {
        func = (args: IncomeDecisionProps) => {
          track("cur8:manageEarningsSavePreference_updated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "addBankAccountClicked": {
        func = (args: AddBankAccountProps) => {
          track("cur8:manageEarningsAddBankAccount_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "commitmentDetailsPageViewed": {
        func = (args: CommitmentDetailsPageViewedProps) => {
          track("cur8:commitmentDetails_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "commitmentFlowPageViewed": {
        func = (args: CommitmentFlowPageViewedProps) => {
          track("cur8:commitmentFlow_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "investmentCommitted": {
        func = (args: InvestmentCommitted) => {
          track("cur8:investmentCommitted", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "paymentConfirmed": {
        func = (args: PaymentConfirmed) => {
          track("cur8:paymentConfirmed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "plaidPaymentInitiated": {
        func = (args: PlaidPaymentProps) => {
          track("cur8:plaidPayment_initiated", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "plaidPaymentFailed": {
        func = (args: PlaidPaymentProps) => {
          track("cur8:plaidPayment_failed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "plaidPaymentConfirmed": {
        func = (args: PlaidPaymentProps) => {
          track("cur8:plaidPayment_confirmed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealBotOpened": {
        func = (args: DealBotOpenedProps) => {
          track("cur8:dealBot_opened", {
            deal_name: args.deal_name,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotClosed": {
        func = (args: DealBotClosedProps) => {
          track("cur8:dealBot_closed", {
            deal_name: args.deal_name,
            total_messages: args.total_messages,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotQuestionSent": {
        func = (args: DealBotQuestionSentProps) => {
          track("cur8:dealBot_questionSent", {
            deal_name: args.deal_name,
            character_count: args.character_count,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotResponseReceived": {
        func = (args: DealBotResponseReceivedProps) => {
          track("cur8:dealBot_responseReceived", {
            deal_name: args.deal_name,
            response_time_secs: args.response_time_secs,
            character_count: args.character_count,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotError": {
        func = (args: DealBotErrorProps) => {
          track("cur8:dealBot_error", {
            deal_name: args.deal_name,
            error_message: args.error_message,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "taxResidencySaved": {
        func = (args: TaxResidencyProps) => {
          track("cur8:taxResidency_residencySaved", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "taxResidencyDeleted": {
        func = (args: TaxResidencyProps) => {
          track("cur8:taxResidency_residencyDeleted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "taxResidencyUpdated": {
        func = (args: TaxResidencyProps) => {
          track("cur8:taxResidency_residencyUpdated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "dealBotFeedbackSubmitted": {
        func = (args: DealBotFeedbackSubmittedProps) => {
          track("cur8:dealBot_feedbackSubmitted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotDealChanged": {
        func = (args: DealBotDealChangedProps) => {
          track("cur8:dealBot_dealChanged", {
            current_deal_name: args.current_deal_name,
            selected_deal_name: args.selected_deal_name,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealBotConversationDeleted": {
        func = (args: DealBotConversationDeletedProps) => {
          track("cur8:dealBot_conversationDeleted", {
            deal_name: args.deal_name,
            session_id: args.session_id,
            conversation_id: args.conversation_id,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsTabClicked": {
        func = ({
          deal_name,
          tab,
          deal_card_state,
        }: DealDetailsTabClickedProps) => {
          track("cur8:dealDetailsTab_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
            tab,
            ...(deal_card_state ? { deal_card_state } : {}),
          });
        };

        break;
      }

      case "dealDetails_pageViewed": {
        func = (args: DealDetailsPageViewedProps) => {
          track("cur8:dealDetails_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "investmentUpdatesTabClicked": {
        func = ({ deal_name, source }: InvestmentUpdatesTabClickedProps) => {
          track("cur8:investmentUpdatesTab_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
            source,
          });
        };

        break;
      }

      case "investmentUpdateViewed": {
        func = ({
          deal_id,
          deal_name,
          update_post_id,
          update_post_title,
          source,
        }: InvestmentUpdateViewedProps) => {
          track("cur8:investmentUpdate_viewed", {
            app: APP_NAME,
            channel,
            ...(deal_id ? { deal_id } : {}),
            deal_name,
            update_post_id,
            update_post_title,
            source,
          });
        };

        break;
      }

      case "dealDetailsInvestBlockedShown": {
        func = (args: DealDetailsInvestBlockedShownProps) => {
          track("cur8:dealDetailsInvestBlocked_shown", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsInvestClicked": {
        func = (args: DealDetailsInvestClickedProps) => {
          track("cur8:dealDetailsInvest_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsDocumentOpened": {
        func = (args: DealDetailsDocumentOpenedProps) => {
          track("cur8:dealDetailsDocument_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsCalculatorUsed": {
        func = (args: DealDetailsCalculatorUsedProps) => {
          track("cur8:dealDetailsCalculator_used", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsVideoPlayed": {
        func = (args: DealDetailsVideoPlayedProps) => {
          track("cur8:dealDetailsVideo_played", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsWebinarClicked": {
        func = (args: DealDetailsWebinarClickedProps) => {
          track("cur8:dealDetailsWebinar_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsGlossaryOpened": {
        func = (args: DealDetailsGlossaryOpenedProps) => {
          track("cur8:dealDetailsGlossary_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsManageHoldingOpened": {
        func = (args: DealDetailsManageHoldingOpenedProps) => {
          track("cur8:dealDetailsManageHolding_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsManageHoldingOptionClicked": {
        func = (args: DealDetailsManageHoldingOptionClickedProps) => {
          track("cur8:dealDetailsManageHolding_optionClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealDetailsShariaCtaClicked": {
        func = (args: DealDetailsShariaCtaClickedProps) => {
          track("cur8:dealDetailsShariaCta_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "watchlistButtonClicked": {
        func = (args: WatchlistButtonClickedProps) => {
          track("cur8:watchlist_buttonClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "quizStarted": {
        func = (args: QuizStartedProps) => {
          track("cur8:quiz_started", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "quizQuestionCompleted": {
        func = (args: QuizQuestionCompletedProps) => {
          track("cur8:quiz_question_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "quizAbandoned": {
        func = (args: QuizAbandonedProps) => {
          track("cur8:quiz_abandoned", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "quizHelpModalOpened": {
        func = (args: QuizHelpModalOpenedProps) => {
          track("cur8:quiz_help", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "feedbackFormViewed": {
        func = (args: FeedbackFormViewedProps) => {
          track("cur8:feedbackForm_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "homePageViewed": {
        func = () => {
          track("cur8:homePage_viewed", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "homePageTaskClicked": {
        func = ({ task_name }: { task_name: string }) => {
          track("cur8:homePageTask_clicked", {
            app: APP_NAME,
            channel,
            task_name,
          });
        };

        break;
      }

      case "homePageTaskDismissed": {
        func = ({ task_name }: { task_name: string }) => {
          track("cur8:homePageTask_dismissed", {
            app: APP_NAME,
            channel,
            task_name,
          });
        };

        break;
      }

      case "homePageUpdateSeeAllClicked": {
        func = () => {
          track("cur8:homePageUpdate_seeAll_clicked", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "mobileNavClicked": {
        func = ({ page_name }: { page_name: string }) => {
          track("cur8:mobileNav_clicked", {
            app: APP_NAME,
            channel,
            page_name,
          });
        };

        break;
      }

      case "homePageDealClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:homePageDeal_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      case "homePageInvestmentUpdatesClicked": {
        func = ({ deal_name }: TimelineEventProps) => {
          track("cur8:homePageInvestmentUpdates_clicked", {
            app: APP_NAME,
            channel,
            deal_name,
          });
        };

        break;
      }

      // FCA trust-related events
      case "headerFCAClicked": {
        func = ({ source_page }: HeaderFCAClickedProps) => {
          track("cur8:headerFCA_clicked", {
            app: APP_NAME,
            channel,
            source_page,
          });
        };

        break;
      }

      case "financialRegulationViewed": {
        func = () => {
          track("cur8:financialRegulation_viewed", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "shariaComplianceClicked": {
        func = (args: ShariaComplianceClickedProps) => {
          track("cur8:shariaCompliance_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "shariaCompliancePageViewed": {
        func = (args: ShariaCompliancePageViewedProps) => {
          track("cur8:shariaCompliance_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "startupHubViewed": {
        func = (args: StartupHubViewedProps) => {
          track("cur8:startupHub_viewed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "startupHubFilterClicked": {
        func = (args: StartupHubFilterClickedProps) => {
          track("cur8:startupHub_filterClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "startupHub_eisCertificateClicked": {
        func = (args: StartupHubEisCertificateClickedProps) => {
          track("cur8:startupHub_eisCertificateClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "startupHub_eisExplanationClicked": {
        func = (args: StartupHubEisExplanationClickedProps) => {
          track("cur8:startupHub_eisExplanationClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "startupHub_glossaryClicked": {
        func = (args: StartupHubGlossaryClickedProps) => {
          track("cur8:startupHub_glossaryClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "startupHub_eisDocumentsClicked": {
        func = (args: StartupHubEisDocumentsClickedProps) => {
          track("cur8:startupHub_eisDocumentsClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "homepageIntroductionStarted": {
        func = (args: HomepageIntroductionStartedProps) => {
          track("cur8:homepageIntroduction_started", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "homepageIntroductionStepViewed": {
        func = (args: HomepageIntroductionStepViewedProps) => {
          track("cur8:homepageIntroduction_stepViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "homepageIntroductionSkipped": {
        func = (args: HomepageIntroductionSkippedProps) => {
          track("cur8:homepageIntroduction_skipped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "homepageIntroductionCompleted": {
        func = (args: HomepageIntroductionCompletedProps) => {
          track("cur8:homepageIntroduction_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealTourOpened": {
        func = (args: DealTourOpenedProps) => {
          track("cur8:dealTour_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealTourStepViewed": {
        func = (args: DealTourStepViewedProps) => {
          track("cur8:dealTour_stepViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealTourExited": {
        func = (args: DealTourExitedProps) => {
          track("cur8:dealTour_exited", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealTourCompleted": {
        func = (args: DealTourCompletedProps) => {
          track("cur8:dealTour_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaCtaViewed": {
        func = (args: IfIsaCtaProps) => {
          track("cur8:ifisaCta_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaCtaClicked": {
        func = (args: IfIsaCtaProps) => {
          track("cur8:ifisaCta_clicked", { ...args, app: APP_NAME, channel });
        };

        break;
      }

      case "ifIsaCtaDismissed": {
        func = (args: IfIsaCtaDismissedProps) => {
          track("cur8:ifisaCta_dismissed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaPermanentPageViewed": {
        func = (args: IfIsaFullSourceProps) => {
          track("cur8:ifisaPermanentPage_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaDescriptionPageViewed": {
        func = (args: IfIsaFullSourceProps) => {
          track("cur8:ifisaDescriptionPage_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaProceedToDeclarationClicked": {
        func = (args: IfIsaFullSourceProps) => {
          track("cur8:ifisaProceedToDeclaration_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaConfirmRegistrationClicked": {
        func = (args: IfIsaFullSourceProps) => {
          track("cur8:ifisaConfirmRegistration_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaRegistrationSuccessViewed": {
        func = (args: IfIsaFullSourceProps) => {
          track("cur8:ifisaRegistrationSuccess_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInCtaClicked": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInCTA_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaExistingTransfersInCtaClicked": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaExistingTransfersInCTA_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInStartViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInStart_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInDealViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInDeal_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInProviderViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInProvider_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInIsaSelectionViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInIsaSelection_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInIsaDetailsViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInIsaDetails_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInSummaryViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInSummary_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInNoticePeriodViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInNoticePeriod_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInAuthorisationsViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInAuthorisations_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInDeclarationViewed": {
        func = (args: UserIdIsMemberBaseProps) => {
          track("cur8:ifisaTransferInDeclaration_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "ifIsaTransferInRequestSuccessViewed": {
        func = (args: IfIsaTransferInSubmitFormProps) => {
          track("cur8:ifisaTransferInRequestSuccess_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonStarted": {
        func = () => {
          track("cur8:dealComparison_Started", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonViewed": {
        func = (args: DealComparisonViewedProps) => {
          track("cur8:dealComparison_Viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonDealSelected": {
        func = (args: DealComparisonDealSelectedProps) => {
          track("cur8:dealComparisonDeal_selected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonCardExpanded": {
        func = (args: DealComparisonCardExpandedProps) => {
          track("cur8:dealComparisonCard_expanded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonSeeDetailsClicked": {
        func = (args: DealComparisonDetailsClickedProps) => {
          track("cur8:dealComparisonSeeDetails_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonCalculateReturnsClicked": {
        func = (args: DealComparisonCalculateReturnsClickedProps) => {
          track("cur8:dealComparisonCalculateReturns_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonCalculateReturnsFailed": {
        func = (args: DealComparisonCalculateReturnsFailedProps) => {
          track("cur8:dealComparisonCalculateReturns_failed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonExited": {
        func = () => {
          track("cur8:dealComparison_exited", {
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealComparisonDealChanged": {
        func = (args: DealComparisonDealChangedProps) => {
          track("cur8:dealComparisonDeal_changed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "cur8CalculatorEntryPointClicked": {
        func = (args: CalculatorEntryPointClickedProps) => {
          track("cur8:calculator_entryPoint_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorViewed": {
        func = (args: CalculatorViewedProps) => {
          track("cur8:calculator_viewed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorEditButtonClicked": {
        func = (args: CalculatorEditButtonClickedProps) => {
          track("cur8:calculator_editButton_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorInvestButtonClicked": {
        func = (args: CalculatorInvestButtonClickedProps) => {
          track("cur8:calculator_investButton_clicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorDealChanged": {
        func = (args: CalculatorDealChangedProps) => {
          track("cur8:calculator_dealChanged", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorChartInteracted": {
        func = (args: CalculatorChartInteractedProps) => {
          track("cur8:calculator_chart_interacted", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorTotalFeesExpanded": {
        func = (args: CalculatorTotalFeesExpandedProps) => {
          track("cur8:calculator_totalFees_expanded", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorFaqOpened": {
        func = (args: CalculatorFaqOpenedProps) => {
          track("cur8:calculator_faq_opened", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorComparisonViewed": {
        func = (args: CalculatorComparisonViewedProps) => {
          track("cur8:calculator_comparison_viewed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "cur8CalculatorConfigurationSubmitted": {
        func = (args: CalculatorConfigurationSubmittedProps) => {
          track("cur8:calculator_configuration_submitted", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "navigationMenuClicked": {
        func = (args: NavigationMenuClickedProps) => {
          track("cur8:navigationMenuItem_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "dealExplorerDealSelected": {
        func = (args: DealExplorerBaseProps) => {
          track("cur8:dealExplorer_dealSelected", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealExplorerPageViewed": {
        func = (args: DealExplorerPageViewedProps) => {
          track("cur8:dealExplorer_pageViewed", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealExplorerInvestNowClicked": {
        func = (args: DealExplorerBaseProps) => {
          track("cur8:dealExplorer_investNowClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealExplorerFinished": {
        func = (args: DealExplorerBaseProps) => {
          track("cur8:dealExplorer_finished", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealExplorerCalculateReturnsClicked": {
        func = (args: DealExplorerBaseProps) => {
          track("cur8:dealExplorer_calculateReturnsClicked", {
            ...args,
            app: APP_NAME,
          });
        };

        break;
      }

      case "dealTimelineInvestmentBreakdownExpandend": {
        func = (args: DealTimelineInvestmentBreakdownExpandendProps) => {
          track("cur8:dealTimelineSummaryCard_expanded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "currentPortfolioValueInfoClicked": {
        func = (args: CurrentPortfolioValueInfoClickedProps) => {
          track("cur8:portfolioLegend_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "timelineGlossaryClicked": {
        func = (args: TimelineGlossaryClickedProps) => {
          track("cur8:timelineLegend_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };

        break;
      }

      case "codePushForceUpdateShown": {
        func = async (args: CodePushForceUpdateShownProps) => {
          track("cur8:codePush_forceUpdateShown", {
            ...args,
            app: APP_NAME,
          });
        };
        break;
      }

      case "codePushForceUpdateAccepted": {
        func = async (args: CodePushForceUpdateAcceptedProps) => {
          track("cur8:codePush_forceUpdateAccepted", {
            ...args,
            app: APP_NAME,
          });
        };
        break;
      }

      case "codePushUpdateCompleted": {
        func = async (args: CodePushUpdateCompletedProps) => {
          track("cur8:codePush_updateCompleted", {
            ...args,
            app: APP_NAME,
          });

          // Set user property for bundle adoption tracking
          // Business Question: "How quickly do users adopt new bundles?"
          if (args.status === "success") {
            mixpanel.people?.set({
              codePush_currentBundleId: args.bundleId,
              codePush_lastUpdateDate: new Date().toISOString(),
            });
          }
        };
        break;
      }

      // =================================================================
      // Nucleus Events
      // =================================================================

      case "nucleusReallocationsUpdated": {
        func = async (args: NucleusReallocationsUpdatedProps) => {
          track("nucleus:reallocations_updated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusBankAccountDetailsMatch": {
        func = async (args: NucleusBankAccountDetailsMatchProps) => {
          track("nucleus:bankAccount_detailsMatch", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusBankAccountPageViewed": {
        func = async (args: NucleusBankAccountPageViewedProps) => {
          track("nucleus:bankAccount_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusSubAppOpened": {
        func = async (args: NucleusSubAppOpenedProps) => {
          track("nucleus:subApp_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusActionFailed": {
        func = async (args: NucleusActionFailedProps) => {
          track("nucleus:action_failed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusLookupSearched": {
        func = async (args: NucleusLookupSearchedProps) => {
          track("nucleus:lookup_searched", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusLookupElementClicked": {
        func = async (args: NucleusLookupElementClickedProps) => {
          track("nucleus:lookup_elementClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusFrozenDayLineOpened": {
        func = async (args: NucleusFrozenDayLineOpenedProps) => {
          track("nucleus:frozenDayLine_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "nucleusFrozenDayLineSaved": {
        func = async (args: NucleusFrozenDayLineSavedProps) => {
          track("nucleus:frozenDayLine_saved", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Page & Navigation Events
      // =================================================================

      case "isaPageViewed": {
        func = (args: IsaPageViewedProps) => {
          track("cur8:isa_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaNavbarClicked": {
        func = (args: IsaNavbarClickedProps) => {
          track("cur8:isaNavbar_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "todoCardClicked": {
        func = (args: TodoCardClickedProps) => {
          track("cur8:todoCard_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaJourneyCtaClicked": {
        func = (args: IsaJourneyCtaClickedProps) => {
          track("cur8:isaJourneyCTA_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Calculator & Reminder Events
      // =================================================================

      case "isaCalculatorConfigurationSubmitted": {
        func = (args: IsaCalculatorConfigurationSubmittedProps) => {
          track("cur8:isaCalculator_configurationSubmitted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaReminderSubmitted": {
        func = (args: IsaReminderSubmittedProps) => {
          track("cur8:isaReminder_submitted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Journey Lifecycle Events
      // =================================================================

      case "isaJourneyStarted": {
        func = (args: IsaJourneyStartedProps) => {
          track("cur8:isaJourney_started", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaJourneyAbandoned": {
        func = (args: IsaJourneyAbandonedProps) => {
          track("cur8:isaJourney_abandoned", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaDeclarationAccepted": {
        func = (args: IsaFlowTypeOnlyProps) => {
          track("cur8:isaDeclaration_accepted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaApplicationSubmitted": {
        func = (args: IsaFlowTypeOnlyProps) => {
          track("cur8:isaApplication_submitted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaCreated": {
        func = (args: IsaFlowTypeOnlyProps) => {
          track("cur8:isa_created", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Transfer Events
      // =================================================================

      case "isaTransferStepCompleted": {
        func = (args: IsaTransferStepCompletedProps) => {
          track("cur8:isaTransfer_stepCompleted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaTransferStatusUpdated": {
        func = (args: IsaTransferStatusUpdatedProps) => {
          track("cur8:isaTransfer_statusUpdated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaTransferCompleted": {
        func = (args: IsaTransferCompletedProps) => {
          track("cur8:isaTransfer_completed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // Commitment Flow ISA Events
      // =================================================================

      case "commitmentCapacityPageViewed": {
        func = (args: CommitmentCapacityPageViewedProps) => {
          track("cur8:commitmentCapacity_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "commitmentIsaPromptViewed": {
        func = (args: CommitmentIsaPromptViewedProps) => {
          track("cur8:commitmentIsaPrompt_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "commitmentNumberPageViewed": {
        func = (args: CommitmentNumberPageViewedProps) => {
          track("cur8:commitmentNumber_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "commitmentReviewViewed": {
        func = (args: CommitmentReviewViewedProps) => {
          track("cur8:commitmentReview_viewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Tracker Event
      // =================================================================

      case "isaTrackerClicked": {
        func = (args: IsaTrackerClickedProps) => {
          track("cur8:isaTracker_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // =================================================================
      // ISA Wrap Request Events
      // =================================================================

      case "isaWrapRequestEntryPointClicked": {
        func = (args: IsaWrapRequestEntryPointClickedProps) => {
          track("cur8:isaWrapRequest_entryPointClicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaWrapRequestFundSelected": {
        func = (args: IsaWrapRequestFundSelectedProps) => {
          track("cur8:isaWrapRequest_fundSelected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaWrapRequestAmountEntered": {
        func = (args: IsaWrapRequestAmountEnteredProps) => {
          track("cur8:isaWrapRequest_amountEntered", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaWrapRequestAllowanceErrorShown": {
        func = (args: IsaWrapRequestAllowanceErrorShownProps) => {
          track("cur8:isaWrapRequest_allowanceErrorShown", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaWrapRequestReviewScreenViewed": {
        func = (args: IsaWrapRequestReviewScreenViewedProps) => {
          track("cur8:isaWrapRequest_reviewScreenViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "isaWrapRequestSubmitted": {
        func = (args: IsaWrapRequestSubmittedProps) => {
          track("cur8:isaWrapRequest_submitted", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // Events module
      case "eventsCardTapped": {
        func = (args: EventsCardTappedProps) => {
          track("cur8:events_cardTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "eventsRegisterTapped": {
        func = (args: EventsRegisterTappedProps) => {
          track("cur8:events_registerTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "eventsJoinNowTapped": {
        func = (args: EventsJoinNowTappedProps) => {
          track("cur8:events_joinNowTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      // --- Earnings Calendar ---

      case "earningsCalendarInvestorPageViewed": {
        func = (args: EarningsCalendarInvestorPageViewedProps) => {
          track("cur8:earningsCalendarInvestor_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsCalendarNonInvestorPageViewed": {
        func = (args: EarningsCalendarNonInvestorPageViewedProps) => {
          track("cur8:earningsCalendarNonInvestor_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsDetailUpcomingPageViewed": {
        func = (args: EarningsDetailUpcomingPageViewedProps) => {
          track("cur8:earningsDetailUpcoming_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsDetailReceivedPageViewed": {
        func = (args: EarningsDetailReceivedPageViewedProps) => {
          track("cur8:earningsDetailReceived_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "manageEarningsPageViewed": {
        func = (args: ManageEarningsPageViewedProps) => {
          track("cur8:manageEarnings_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsCalendarEntryPointClicked": {
        func = (args: EarningsCalendarEntryPointClickedProps) => {
          track("cur8:earningsCalendarEntryPoint_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsCalendarItemClicked": {
        func = (args: EarningsCalendarItemClickedProps) => {
          track("cur8:earningsCalendarItem_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsPreferenceManageClicked": {
        func = (args: EarningsPreferenceManageClickedProps) => {
          track("cur8:earningsPreferenceManage_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsCalendarInvestNowClicked": {
        func = (args: EarningsCalendarInvestNowClickedProps) => {
          track("cur8:earningsCalendarInvestNow_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsDetailPreferenceClicked": {
        func = (args: EarningsDetailPreferenceClickedProps) => {
          track("cur8:earningsDetailPreference_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsDetailContactSupportClicked": {
        func = (args: EarningsDetailContactSupportClickedProps) => {
          track("cur8:earningsDetailContactSupport_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsBankAccountSwitchClicked": {
        func = (args: EarningsBankAccountSwitchClickedProps) => {
          track("cur8:earningsBankAccountSwitch_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "earningsCalendarRetryClicked": {
        func = (args: EarningsCalendarRetryClickedProps) => {
          track("cur8:earningsCalendarRetry_clicked", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureBannerTapped": {
        func = (args: FundRestructureBannerTappedProps) => {
          track("cur8:fundRestructure_bannerTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureIntroViewed": {
        func = () => {
          track("cur8:fundRestructure_intro_pageViewed", {
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureMakeChoiceTapped": {
        func = () => {
          track("cur8:fundRestructure_makeChoiceTapped", {
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureAllocationViewed": {
        func = (args: FundRestructureAllocationViewedProps) => {
          track("cur8:fundRestructure_allocation_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureNoticePeriodSelected": {
        func = (args: FundRestructureNoticePeriodSelectedProps) => {
          track("cur8:fundRestructure_noticePeriodSelected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureIncomeDecisionSelected": {
        func = (args: FundRestructureIncomeDecisionProps) => {
          track("cur8:fundRestructure_incomeDecisionSelected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureSubmitAttempted": {
        func = (args: FundRestructureSubmitProps) => {
          track("cur8:fundRestructure_reviewConfirmTapped", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureSubmitSucceeded": {
        func = (args: FundRestructureSubmitSucceededProps) => {
          track("cur8:fundRestructure_submitSucceeded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureSuccessViewed": {
        func = (args: FundRestructureSuccessViewedProps) => {
          track("cur8:fundRestructure_success_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundRestructureSummaryViewed": {
        func = (args: FundRestructureSummaryViewedProps) => {
          track("cur8:fundRestructure_summary_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "portfolioStatementOpened": {
        func = (args: PortfolioStatementOpenedProps) => {
          track("cur8:portfolioStatement_opened", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "portfolioStatementPeriodSelected": {
        func = (args: PortfolioStatementPeriodSelectedProps) => {
          track("cur8:portfolioStatement_periodSelected", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "portfolioStatementGenerated": {
        func = (args: PortfolioStatementGeneratedProps) => {
          track("cur8:portfolioStatement_generated", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "portfolioStatementDownloaded": {
        func = (args: PortfolioStatementDownloadedProps) => {
          track("cur8:portfolioStatement_downloaded", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "transitionFlowInteraction": {
        func = (args: TransitionFlowProps) => {
          track("cur8:transitionFlow_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "activityReceiptPageViewed": {
        func = (args: ActivityReceiptPageViewedProps) => {
          track("cur8:activityReceipt_pageViewed", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "activityTimelineInteraction": {
        func = (args: ActivityTimelineInteractionProps) => {
          track("cur8:activityTimeline_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "liveDealsInteraction": {
        func = (args: LiveDealsInteractionProps) => {
          track("cur8:liveDeals_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "fundOverviewInteraction": {
        func = (args: FundOverviewInteractionProps) => {
          track("cur8:fundOverview_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "portfolioInteraction": {
        func = (args: PortfolioInteractionProps) => {
          track("cur8:portfolio_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "homePageInteraction": {
        func = (args: HomePageInteractionProps) => {
          track("cur8:homePage_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "notificationsInteraction": {
        func = (args: NotificationsInteractionProps) => {
          track("cur8:notifications_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      case "dealDetailsInteraction": {
        func = (args: DealDetailsInteractionProps) => {
          track("cur8:dealDetails_interaction", {
            ...args,
            app: APP_NAME,
            channel,
          });
        };
        break;
      }

      default:
        func = () => {
          console.log("Analytics operation failed");
        };

        break;
    }

    return func as EventType<T>;
  };
};

export type {
  cur8PageViewEvents,
  CalculatorFaqId,
  PageViewProps,
  AppNames,
  AnalyticsActions,
  EventType,
  BankVerificationMethodSelectedProps,
  BankVerificationAttemptedProps,
  BankAccountsConnectedProps,
  BankAccountsUpdatedProps,
  BankAccountsRulesViewedProps,
  BankAccountsFailureViewedProps,
  BankAccountsFailureActionClickedProps,
  CommitmentEarningsViewedProps,
  CommitmentEarningsSelectedProps,
  CurrencyWarningRespondedProps,
  BankAccountsPageViewedProps,
  BankAccountCapacity,
  BankAccountStatusProperty,
  BankAccountEntryPoint,
  BankAccountVerificationFailureReason,
  EarningsBankAccountSource,
  BankAccountCapacityProps,
  BankAccountSetProps,
  NotificationProps,
  NotificationAcceptance,
  NotificationCtaPrompt,
  NotificationDeliveredProps,
  NotificationOpenedProps,
  CodePushForceUpdateShownProps,
  CodePushForceUpdateAcceptedProps,
  CodePushUpdateCompletedProps,
  NucleusEntryPoint,
  IsaFlowType,
  IsaSpendBucket,
  InvestmentCapacity,
  DealStatus,
  IsaPageViewedProps,
  IsaNavbarClickedProps,
  TodoCardClickedProps,
  IsaJourneyCtaClickedProps,
  IsaCalculatorConfigurationSubmittedProps,
  IsaReminderSubmittedProps,
  IsaJourneyStartedProps,
  IsaJourneyAbandonedProps,
  IsaFlowTypeOnlyProps,
  IsaTransferStepCompletedProps,
  IsaTransferStatusUpdatedProps,
  IsaTransferCompletedProps,
  CommitmentCapacityPageViewedProps,
  CommitmentIsaPromptViewedProps,
  CommitmentNumberPageViewedProps,
  CommitmentReviewViewedProps,
  IsaTrackerClickedProps,
  IsaWrapRequestEntryPointClickedProps,
  IsaWrapRequestFundSelectedProps,
  IsaWrapRequestAmountEnteredProps,
  IsaWrapRequestAllowanceErrorShownProps,
  IsaWrapRequestReviewScreenViewedProps,
  IsaWrapRequestSubmittedProps,
  EventsCardTappedProps,
  EventsRegisterTappedProps,
  EventsJoinNowTappedProps,
  EarningsCalendarInvestorPageViewedProps,
  EarningsCalendarNonInvestorPageViewedProps,
  EarningsDetailUpcomingPageViewedProps,
  EarningsDetailReceivedPageViewedProps,
  ManageEarningsPageViewedProps,
  EarningsCalendarEntryPointClickedProps,
  EarningsCalendarItemClickedProps,
  EarningsPreferenceManageClickedProps,
  EarningsCalendarInvestNowClickedProps,
  EarningsDetailPreferenceClickedProps,
  EarningsDetailContactSupportClickedProps,
  EarningsBankAccountSwitchClickedProps,
  EarningsCalendarRetryClickedProps,
  FundRestructureBannerTappedProps,
  FundRestructureAllocationViewedProps,
  FundRestructureNoticePeriodSelectedProps,
  FundRestructureIncomeDecisionProps,
  FundRestructureSubmitProps,
  FundRestructureSubmitSucceededProps,
  FundRestructureSuccessViewedProps,
  FundRestructureSummaryViewedProps,
  PortfolioStatementAccountType,
  PortfolioStatementPeriodType,
  PortfolioStatementOpenedProps,
  PortfolioStatementPeriodSelectedProps,
  PortfolioStatementGeneratedProps,
  PortfolioStatementDownloadedProps,
  AuthMethod,
  TwoFaMethod,
  AuthSignupFailedProps,
  AuthLoginSuccessProps,
  AuthLoginFailedProps,
  AuthTwoFaRequiredProps,
  AuthTwoFaFailedProps,
  AuthEmailVerificationFailedProps,
  OnboardingMandatoryQuestionAnsweredProps,
  OnboardingMandatoryQuestionnaireCompletedProps,
  OnboardingEmailPreferencesCompletedProps,
  OnboardingSocialAttributionCompletedProps,
  OnboardingExperimentExposedProps,
  OnboardingPreAppGateEnteredProps,
  OnboardingPreAppGateCompletedProps,
  OnboardingDealChecklistSource,
  OnboardingDealChecklistViewedProps,
  OnboardingDealStepClickedProps,
  OnboardingDealContinuationReturnedProps,
  OnboardingDealStepCompletedProps,
  OnboardingDealUnlockedProps,
  OnboardingQuizResultClickedProps,
  OnboardingContinueBannerClickedProps,
  OnboardingVersion,
  OnboardingStep,
  OnboardingNextStep,
  OnboardingCompletedStep,
  OnboardingCardState,
  DealCardState,
  DealCardStateProps,
  OnboardingCtaPosition,
  OnboardingReturnReason,
  OnboardingDestination,
  OnboardingQuizResult,
  OnboardingQuizResultAction,
  DealDetailsInvestClickedProps,
  OnboardingAnalyticsProps,
  OnboardingBasicInfoCompletedProps,
  OnboardingCertificationSelectedProps,
  OnboardingAccreditationCompletedProps,
  OnboardingQuizFailedProps,
  OnboardingVerificationDocumentUploadedProps,
  OnboardingVerificationUploadFailedProps,
  OnboardingVerificationCompletedProps,
  OnboardingBackPressedProps,
  OnboardingHelpTappedProps,
  OnboardingSectionFailedProps,
  TransitionFlowProps,
  DealDetailsSectionTab,
  DealDetailsInteractionDetail,
  TransitionSubmitFailureReason,
  TransitionBackendRecord,
  TransitionFlowAction,
  ActivityTimelineInteractionProps,
  LiveDealsInteractionProps,
  FundOverviewInteractionProps,
  PortfolioInteractionProps,
  HomePageInteractionProps,
  NotificationsInteractionProps,
  DealDetailsInteractionProps,
  TransitionFlowName,
  TransitionStepName,
  TransitionRequestKindName,
  TransitionAmountMode,
  TransitionDirection,
  ActivityReceiptPageViewedProps,
  NucleusLookupElement,
  NucleusLookupSearchedProps,
  NucleusLookupElementClickedProps,
  NucleusFrozenDayLineOpenedProps,
  NucleusFrozenDayLineSavedProps,
};
